import { CONTENT_BY_MODULE } from "./content/index.js";
export const TRAINING_MODULES = [
    { key: "inicio", title: "Primeros pasos", order: 1 },
    { key: "mostrador", title: "Mostrador", order: 2 },
    { key: "socios", title: "Socios", order: 3 },
    { key: "clases", title: "Clases", order: 4 },
    { key: "kiosko", title: "Kiosko", order: 5 },
    { key: "personal", title: "Personal", order: 6 },
    { key: "caja", title: "Caja y cierres", order: 7 },
    { key: "facturacion", title: "Facturación e impuestos", order: 8 },
    { key: "gastos", title: "Gastos", order: 9 },
    { key: "comunicacion", title: "Comunicación", order: 10 },
    { key: "reportes", title: "Reportes y alertas", order: 11 },
    { key: "configuracion", title: "Configuración", order: 12 },
    { key: "profes", title: "Portal de profesores", order: 13 },
];
const ROLE_LETTER = {
    D: "owner",
    A: "admin",
    C: "intersede_coordinator",
    E: "branch_manager",
    R: "receptionist",
    P: "teacher",
    K: "accountant_readonly",
};
/** Letras de la tabla → roles, en el orden canónico de `USER_ROLES`. */
export function rolesFromLetters(letters) {
    const roles = [...letters].map((letter) => {
        const role = ROLE_LETTER[letter];
        if (!role)
            throw new Error(`Letra de rol desconocida en el catálogo: ${letter}`);
        return role;
    });
    const order = Object.values(ROLE_LETTER);
    return [...new Set(roles)].sort((a, b) => order.indexOf(a) - order.indexOf(b));
}
/** La tabla aprobada, en orden. `null` = lección conceptual, sin pantalla. */
// prettier-ignore
const GRID = [
    ["inicio", "inicio.bienvenida", "Para qué está el sistema y cómo usar este curso", "DACERPK", null, false],
    ["inicio", "inicio.ingreso", "Entrar al sistema: contraseña, código por mail y Mi cuenta", "DACERPK", "cuenta.mi-cuenta", false],
    ["inicio", "inicio.sede-menu", "La sede activa y el menú por grupos", "DACERPK", "roles.sede-activa", false],
    ["inicio", "inicio.motivos", "Acciones sensibles: por qué el sistema te pide un motivo", "DACER", null, true],
    ["mostrador", "mostrador.cobrar", "Cobrar en el mostrador (efectivo, posnet, Mercado Pago, transferencia)", "RECAD", "planes.cobrar", true],
    ["mostrador", "mostrador.descuentos", "Descuentos y cobros con excepción", "RECAD", "planes.cobrar", true],
    ["mostrador", "mostrador.caja-turno", "La caja del turno: abrir, movimientos y retiros", "RECAD", "caja.turno", true],
    ["mostrador", "mostrador.cierre-turno", "Cerrar el turno a ciegas y armar el sobre", "RECAD", "caja.cierre", true],
    ["mostrador", "mostrador.ingresos", "Ingresos y semáforo: qué hacer cuando el molinete no deja pasar", "RECAD", "acceso.ingresos", false],
    ["mostrador", "mostrador.visitantes", "Visitantes SportClub y Wellhub", "RECAD", "socios.visitantes", true],
    ["mostrador", "mostrador.interesados", "Interesados: cargar y hacer el seguimiento", "RECAD", "crm.interesados", true],
    ["mostrador", "mostrador.mensajes", "Mensajes de la sede", "RECAD", "crm.mensajes", false],
    ["mostrador", "mostrador.mis-comisiones", "Mis comisiones", "R", "profesores.mis-comisiones", false],
    ["socios", "socios.alta", "Alta presencial de un socio, con firma en la tablet", "RECAD", "socios.alta", true],
    ["socios", "socios.huella-qr", "Huella, QR e invitación a la app", "RECAD", "socios.ficha", false],
    ["socios", "socios.padron-ficha", "El padrón y la ficha 360° del socio", "RECAD", "socios.padron", false],
    ["socios", "socios.cuenta-corriente", "La cuenta corriente del socio", "RECAD", "planes.cuenta-corriente", false],
    ["socios", "socios.grupos-familiares", "Grupos familiares", "RECAD", "socios.grupos", false],
    ["socios", "socios.emergencias", "Emergencias médicas", "RECAD", "socios.retiro-emergencia", false],
    ["socios", "socios.debitos", "Débitos automáticos: alta y baja con consentimiento", "RECAD", "planes.debitos", true],
    ["socios", "socios.deudores", "Deudores: cómo gestionar la mora", "RECAD", "planes.deudores", true],
    ["socios", "socios.convenios", "Convenios, canjes y cortesías", "ECAD", "socios.convenios", false],
    ["socios", "socios.duplicados", "Fusión de socios duplicados", "AD", "socios.duplicados", false],
    ["clases", "clases.grilla-consulta", "La grilla de la sede (consulta)", "R", "clases.grilla-consulta", false],
    ["clases", "clases.grilla", "Armar y publicar la grilla del mes", "ECAD", "clases.grilla", true],
    ["clases", "clases.ficha", "La ficha de clase: lista, reservas y suspensiones", "RECAD", "clases.ficha", true],
    ["clases", "clases.ocupacion", "Ocupación y asistencia", "ECAD", "clases.ocupacion", false],
    ["clases", "clases.eventos", "Eventos (master y Viva Games)", "ECAD", "clases.eventos", false],
    ["kiosko", "kiosko.vender", "Vender en el kiosko", "RECAD", "contable.pos", true],
    ["kiosko", "kiosko.ventas", "Ventas del día y anulaciones", "RECAD", "kiosko.ventas", false],
    ["kiosko", "kiosko.stock", "Stock y conteo", "RECAD", "contable.stock", true],
    ["kiosko", "kiosko.productos", "Productos y precios del kiosko", "AD", "contable.productos", false],
    ["kiosko", "kiosko.tablets", "Las tablets públicas: qué ve el socio y cómo se configuran", "ECAD", "kiosko.tablets", false],
    ["personal", "personal.legajos", "Personal y legajos", "ECAD", "profesores.legajos", false],
    ["personal", "personal.turnos", "Turnos y fichajes del equipo", "ECAD", "profesores.turnos", false],
    ["personal", "personal.tarifario", "Tarifario y multiplicadores", "ECAD", "profesores.tarifario", false],
    ["personal", "personal.premios", "Premios por clase", "ECAD", "profesores.varas", false],
    ["personal", "personal.objetivos", "Objetivos y comisiones de recepción", "ECAD", "profesores.objetivos", false],
    ["personal", "personal.liquidacion", "La liquidación del mes, de la pre-liquidación al cierre", "ECAD", "profesores.preliquidacion", true],
    ["caja", "caja.cierres-sobres", "Cierres de turno y sobres", "AD", "caja.historial", false],
    ["caja", "caja.diferencias", "Diferencias y arqueos", "CAD", "caja.diferencias", false],
    ["caja", "caja.conciliacion", "Conciliación con Payway, Mercado Pago e Interbanking", "AD", "caja.conciliacion", true],
    ["caja", "caja.cierres-sedes", "Los cierres de todas las sedes", "ECADK", "reportes.cierres", false],
    ["facturacion", "facturacion.como-factura", "Cómo factura el sistema: A, B, C, el CAE y qué pasa si ARCA no responde", "RECADK", null, false],
    ["facturacion", "facturacion.comprobantes", "Comprobantes y notas de crédito", "ADK", "contable.comprobantes", true],
    ["facturacion", "facturacion.emisores", "Emisores fiscales", "AD", "contable.emisores", false],
    ["facturacion", "facturacion.exportes", "Exportes contables", "ADK", "contable.exportes", false],
    ["facturacion", "facturacion.plataformas", "Liquidación de plataformas (SportClub y Wellhub)", "CADK", "contable.convenios", false],
    ["gastos", "gastos.egresos", "Cargar un egreso", "READK", "contable.egresos", true],
    ["gastos", "gastos.proveedores", "Proveedores", "ADK", "contable.proveedores", false],
    ["comunicacion", "comunicacion.campanas", "Campañas a socios", "CAD", "crm.campanas", true],
    ["comunicacion", "comunicacion.noticias", "Noticias y moderación del muro", "CAD", "crm.moderacion", false],
    ["reportes", "reportes.tablero", "El tablero del dueño y el aviso de las 21:00", "AD", "dashboard", false],
    ["reportes", "reportes.plata", "Recaudación mensual", "DAK", "reportes.recaudacion", false],
    // Sin K: el contador no abre el reporte de facturación (pantalla y API piden de recepción para arriba).
    ["reportes", "reportes.facturacion", "El reporte de facturación", "RECAD", "reportes.facturacion", false],
    ["reportes", "reportes.resultado", "Resultado por sede y por actividad", "AD", "contable.resultado", false],
    ["reportes", "reportes.socios", "Socios activos", "RECAD", "reportes.socios-activos", false],
    ["reportes", "reportes.asistencia", "El reporte de asistencia", "RECAD", "reportes.asistencia", false],
    ["reportes", "reportes.en-riesgo", "No renovados y en riesgo", "RECAD", "reportes.en-riesgo", false],
    ["reportes", "reportes.objetivos", "Objetivos por recepcionista", "RECAD", "reportes.objetivos", false],
    ["reportes", "reportes.alertas-negocio", "Alertas del negocio", "CAD", "reportes.alertas-negocio", false],
    ["reportes", "reportes.alertas-seguridad", "Alertas de seguridad", "CAD", "roles.alertas-seguridad", false],
    ["reportes", "reportes.auditoria", "Auditoría: quién hizo qué, cuándo y por qué", "AD", "roles.auditoria", true],
    ["configuracion", "config.planes", "Planes y precios (listas con vigencia)", "AD", "planes.catalogo", true],
    ["configuracion", "config.promociones", "Promociones", "AD", "planes.promociones", false],
    ["configuracion", "config.textos-legales", "Textos legales", "AD", "socios.textos-legales", false],
    ["configuracion", "config.sedes-salones", "Sedes, locales y salones", "ECAD", "config.sedes", false],
    ["configuracion", "config.disciplinas", "Disciplinas", "ECAD", "config.disciplinas", false],
    ["configuracion", "config.acceso-dispositivos", "Puntos de acceso y dispositivos (molinetes y lectores)", "ECAD", "acceso.puntos", false],
    ["configuracion", "config.cuentas-terminales", "Cuentas y terminales de cobro", "ECAD", "caja.configuracion", false],
    ["configuracion", "config.usuarios", "Usuarios y permisos", "ECAD", "roles.usuarios", true],
    ["configuracion", "config.parametros", "Parámetros y catálogos", "ECAD", "config.parametros", false],
    ["configuracion", "config.integraciones", "Integraciones (Payway, ARCA, Mercado Pago, mail…)", "AD", "config.integraciones", false],
    ["configuracion", "config.sistema", "Tareas automáticas y salud del sistema", "CAD", "config.jobs", false],
    ["configuracion", "config.puesta-en-marcha", "Puesta en marcha: migración, checklist y encendido por sede", "ECAD", "migracion.checklist", false],
    ["configuracion", "config.seguimiento", "Seguimiento de la capacitación del equipo", "ECAD", "capacitacion.equipo", false],
    ["profes", "profes.inicio-agenda", "Tu inicio y tu agenda", "P", "profes.home", false],
    ["profes", "profes.tomar-lista", "Tomar lista en la clase", "P", "profes.lista-clase", true],
    ["profes", "profes.fichar", "Fichar entrada y salida", "P", "kiosko.fichaje", true],
    ["profes", "profes.mi-mes", "Mi mes: la liquidación en curso", "P", "profes.mi-mes", false],
    ["profes", "profes.liquidaciones", "Mis liquidaciones", "P", "profes.liquidaciones", false],
    ["profes", "profes.clases-avisos", "Mis clases y avisos", "P", "profes.mis-clases", false],
    ["profes", "profes.privacidad", "Qué ves de un socio, y qué no", "P", null, false],
];
function buildLessons() {
    return GRID.map(([module, key, title, letters, screenId, hasPractice]) => {
        const content = CONTENT_BY_MODULE[module].lessons[key];
        if (!content)
            throw new Error(`Falta el contenido de la lección ${key}`);
        return {
            key,
            module,
            title,
            roles: rolesFromLetters(letters),
            screenId,
            hasPractice,
            summary: content.summary,
            keyPoints: content.keyPoints,
            estimatedMin: content.estimatedMin,
            contentVersion: content.contentVersion,
        };
    });
}
/** Las 83 lecciones, en el orden del curso. */
export const TRAINING_LESSONS = buildLessons();
const LESSONS_BY_KEY = new Map(TRAINING_LESSONS.map((lesson) => [lesson.key, lesson]));
export function getTrainingLesson(key) {
    return LESSONS_BY_KEY.get(key);
}
export function getTrainingModule(key) {
    const found = TRAINING_MODULES.find((m) => m.key === key);
    if (!found)
        throw new Error(`Módulo de capacitación desconocido: ${key}`);
    return found;
}
/** Lecciones que cursa un rol, en el orden del curso. */
export function lessonsForRole(role) {
    return TRAINING_LESSONS.filter((lesson) => lesson.roles.includes(role));
}
/** El recorrido del rol: módulos (sólo los que tienen algo para él) con sus lecciones. */
export function trackForRole(role) {
    const lessons = lessonsForRole(role);
    return TRAINING_MODULES.map((module) => ({
        ...module,
        lessons: lessons.filter((lesson) => lesson.module === module.key),
    })).filter((module) => module.lessons.length > 0);
}
/**
 * Huella del curso de un rol: cambia si se agrega, saca o actualiza una lección suya. Va en
 * el certificado para saber si se emitió sobre el curso vigente (FNV-1a de 32 bits: es un
 * identificador de versión, no un control de seguridad).
 */
export function trainingCatalogVersion(role) {
    const text = lessonsForRole(role)
        .map((lesson) => `${lesson.key}@${lesson.contentVersion}`)
        .join("|");
    let hash = 0x811c9dc5;
    for (let i = 0; i < text.length; i += 1) {
        hash ^= text.charCodeAt(i);
        hash = Math.imul(hash, 0x01000193) >>> 0;
    }
    return `${lessonsForRole(role).length}-${hash.toString(16).padStart(8, "0")}`;
}
//# sourceMappingURL=catalog.js.map